export default "__VITE_ASSET__V1JqiV_t__"